// Turns a table's `full_set_filters` (the chat apply_filters rule shape:
// {filters: [{field, operator, value, value2}]}) into the URL params the
// transactions view's filter store already parses on load
// (src/stores/filters/storageOptions.ts). An unrecognized shape returns
// null and the footer renders as plain text instead of a broken link.

const OP_TO_SHORT: Record<string, string> = {
  equals: 'eq',
  not_equals: 'ne',
  greater_than: 'gt',
  greater_than_or_equal: 'gte',
  less_than: 'lt',
  less_than_or_equal: 'lte',
  between: 'btw',
  contains: 'has',
  not_contains: 'nothas',
  starts_with: 'sw',
  ends_with: 'ew',
  in: 'in',
  not_in: 'notin',
  before: 'before',
  after: 'after',
}

interface FilterRule {
  field: string
  operator: string
  value: unknown
  value2?: unknown
}

function isFilterRule(candidate: unknown): candidate is FilterRule {
  if (!candidate || typeof candidate !== 'object') return false
  const rule = candidate as Record<string, unknown>
  return typeof rule.field === 'string' && typeof rule.operator === 'string'
}

function encodeValue(value: unknown): string {
  if (Array.isArray(value)) return JSON.stringify(value)
  if (value === null) return 'null'
  return String(value ?? '')
}

export function fullSetFiltersQuery(
  fullSetFilters: Record<string, unknown> | null | undefined,
): string | null {
  const rules = fullSetFilters?.filters
  if (!Array.isArray(rules) || rules.length === 0) return null

  const params = new URLSearchParams()
  for (const candidate of rules) {
    if (!isFilterRule(candidate)) continue
    const shortOp = OP_TO_SHORT[candidate.operator]
    if (!shortOp) continue
    let value = encodeValue(candidate.value)
    if (candidate.value2 !== undefined) {
      value += `_${candidate.value2 === null ? 'null' : String(candidate.value2)}`
    }
    params.set(`${candidate.field}_${shortOp}`, value)
  }
  const query = params.toString()
  return query.length > 0 ? query : null
}
